// Bella Vita frontend — service layer entry.
// Selects the active backend adapter from CONFIG and validates its shape once
// at boot. UI code must import the named services (catalogService, etc.), never
// an adapter or a mock fixture directly.

import { CONFIG } from '../config.js';
import { assertAdapter } from '../adapters/adapterContract.js';
import mockAdapter from '../adapters/mock/index.js';
import odooAdapter from '../adapters/odoo/index.js';

const REGISTRY = { mock: mockAdapter, odoo: odooAdapter };

const adapter = REGISTRY[CONFIG.adapter] || mockAdapter;
assertAdapter(adapter, CONFIG.adapter);

export function getAdapter() {
  return adapter;
}

export { adapter };
